import { useUserContext } from '../user';
import { useWorkspaceContext } from './context';

export interface WorkspaceScope {
  /** False while a client switch is in flight: the session already moved, the workspace on screen has not. */
  ready: boolean;
  workspaceId: string | null;
}

export const useWorkspaceScope = (): WorkspaceScope => {
  const { userSession, switchingClient } = useUserContext() ?? {};
  const { workspace } = useWorkspaceContext() ?? {};
  const defaultWorkspace = workspace?.defaultWorkspace;

  const ready = !switchingClient
    && Boolean(defaultWorkspace?.id)
    && Boolean(defaultWorkspace?.clientId)
    && defaultWorkspace.clientId === userSession?.clientId;

  return { ready, workspaceId: ready ? String(defaultWorkspace.id) : null };
};
